<div [class.home-screen]="isHomeScreen">
  <app-header></app-header>
  <div class="margin-header">
    <router-outlet></router-outlet>
  </div>
</div>
